import PropTypes from "prop-types";
import React from "react";
import withRouter from "./Common/withRouter";
import HeaderOnlyLayout from "./HeaderOnlyLayout";
import VerticalLayout from "./VerticalLayout";
import { useLocation } from "react-router-dom";

const NonAuthLayout = (props) => {
  const location = useLocation();
  
  // Check authentication using localStorage (how this app handles auth)
  const isAuthenticated = !!localStorage.getItem("authUser");

  // For contact us page, show different layouts based on authentication
  if (location.pathname === "/contact-us") {
    return isAuthenticated ? (
      <VerticalLayout>
        {props.children}
      </VerticalLayout>
    ) : (
      <HeaderOnlyLayout>
        {props.children}
      </HeaderOnlyLayout>
    );
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

export default withRouter(NonAuthLayout);
